var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"cursor":"help"}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},'v-tooltip',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }